import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-add-certificate-form',
  templateUrl: './add-certificate-form.component.html',
  styleUrl: './add-certificate-form.component.scss'
})
export class AddCertificateFormComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  userType: string = "";

  constructor(private appService: AppService, private toastr: ToastrService,
    private spinner: NgxSpinnerService, private router: Router) {

  }

  certificateForm = new UntypedFormGroup({
    namePrefix: new UntypedFormControl("", [Validators.required]),
    applicantName: new UntypedFormControl("", [Validators.required]),
    rollNumber: new UntypedFormControl('', [Validators.required]),
    courseDetails: new UntypedFormControl('', [Validators.required]),
    courseStartDate: new UntypedFormControl('', [Validators.required]),
    courseEndDate: new UntypedFormControl('', [Validators.required]),
    issueDate: new UntypedFormControl('', [Validators.required]),
    id: new UntypedFormControl(""),
    endDate: new UntypedFormControl(""),
    description: new UntypedFormControl(""),
    certificateCode: new UntypedFormControl(""),
    createdAt: new UntypedFormControl(""),
    createdBy: new UntypedFormControl(""),
  })

  get f() {
    return this.certificateForm.controls;
  }

  ngOnInit(): void {
    this.userType = localStorage.getItem('userType');
  }


  onSubmit(): void {
    if (this.certificateForm.valid) {
      this.saveCertificateDetails();
    } else {
      this.certificateForm.markAllAsTouched();
    }
  }

  saveCertificateDetails() {
    this.certificateForm.controls['issueDate'].setValue(new Date(this.certificateForm.get('issueDate').value).getTime())
    console.log(this.certificateForm.value)
    this.spinner.show();
    this.appService.saveCertificateDetails(this.certificateForm.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.spinner.hide();
        this.toastr.success('Certificate Details Save Successful');
        this.router.navigate(['/main/admin-certificate-list-table']);
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error.message || "Something Went Wrong,Please Try Again...")
      })
  }

  navigate() {
    this.router.navigate(['/main/invitation-list']);
  }

}
